import React from 'react';
const facts = [{
  value: '60',
  label: 'Ready-to-run meetings'
}, {
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '24',
  label: 'Printable worksheets'
}, {
  value: '3',
  label: 'Age levels, 6 to 17'
}];

// Colores de patrulla del producto
const accents = ['before:bg-patrol-mustard', 'before:bg-patrol-teal', 'before:bg-patrol-plum', 'before:bg-patrol-slate'];
export function SocialProofBar() {
  return <section className="w-full bg-forest-deep" data-id="element-251" data-mp="32il3vcl4lgq7">
      <div className="mx-auto max-w-6xl px-5 pb-12 sm:pb-16" data-id="element-252" data-mp="2xk9u11utz67z">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-forest-line bg-forest-line sm:grid-cols-4" data-id="element-253" data-mp="2xkteoqbv88pp">
          {facts.map((fact, i) => <div key={fact.label} className={`relative bg-forest-deep px-4 py-5 text-center before:absolute before:inset-x-0 before:top-0 before:h-1 before:content-[''] ${accents[i]}`} data-id="element-254" data-mp="2oik1fsp7q18m" data-mpi={i}>
              <div className="font-display text-3xl leading-none text-ember sm:text-4xl" data-id="element-255" data-mp="1d69i0cwczhgu">
                {fact.value}
              </div>
              <div className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-paper/65" data-id="element-256" data-mp="1dnxjav8kg1c7">
                {fact.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}